import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import {
  FilterBase,
  RangeFilterChangeData,
  SearchFilterOptionsData,
  ToggleFilterOptionData,
} from '../../../human-resources/models/filter';

@Component({
  selector: 'md-filter-bar',
  templateUrl: './filter-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterBarComponent extends BaseComponent {
  @Output() resetAllFilters: EventEmitter<boolean> = new EventEmitter();
  @Output() removeFilter: EventEmitter<FilterBase> = new EventEmitter();
  @Output() resetFilter: EventEmitter<FilterBase> = new EventEmitter();
  @Output()
  toggleFilterOption: EventEmitter<ToggleFilterOptionData> = new EventEmitter();
  @Output() addFilter: EventEmitter<FilterBase> = new EventEmitter();
  @Output()
  searchFilterOptions: EventEmitter<SearchFilterOptionsData> = new EventEmitter();
  @Output() searchFilters: EventEmitter<string> = new EventEmitter();
  @Output()
  rangeFilterChange: EventEmitter<RangeFilterChangeData> = new EventEmitter();

  // @ts-expect-error
  @Input() activeFilters: FilterBase[];
  // @ts-expect-error
  @Input() searchedFilters: FilterBase[];
  // @ts-expect-error
  @Input() filtersSearchQuery: string;
  // @ts-expect-error
  @Input() numInactiveFilters: number;

  searchedFiltersVisible = false;

  onRemoveFilter(filter: FilterBase) {
    this.removeFilter.emit(filter);
  }

  onResetFilter(filter: FilterBase) {
    this.resetFilter.emit(filter);
  }

  onSearchFilters(searchFilterQuery: string) {
    this.searchFilters.emit(searchFilterQuery);
  }

  onSearchFilterOptions(searchFilterOptionsData: SearchFilterOptionsData) {
    this.searchFilterOptions.emit(searchFilterOptionsData);
  }

  onToggleFilterOption(toggleFilterOptionData: ToggleFilterOptionData) {
    this.toggleFilterOption.emit(toggleFilterOptionData);
  }

  onResetAllFilters() {
    this.resetAllFilters.emit(true);
  }

  onAddFilter(filter: FilterBase) {
    this.addFilter.emit(filter);
  }

  onRangeFilterChange(rangeFilterChangeData: RangeFilterChangeData) {
    this.rangeFilterChange.emit(rangeFilterChangeData);
  }

  hideSearchedFilters() {
    this.searchedFiltersVisible = false;
  }

  toggleSearchedFiltersVisibility() {
    this.searchedFiltersVisible = !this.searchedFiltersVisible;
  }

  trackFilterDropdown(filter: FilterBase) {
    return filter.name;
  }
}
